import {
    FETCH_LOGGED_IN_USER_ACTION,
    IFetchLoggedInUserAction,
    ILogoutUserAction,
    ISetLoggedInUserAction,
    LOGOUT_USER,
    SET_LOGGED_IN_USER,
} from './types/auth.types';
import {User} from '../../incase-domain/user';

export const fetchLoggedInUserAction = (): IFetchLoggedInUserAction => ({
    type: FETCH_LOGGED_IN_USER_ACTION,
});

export const setLoggedInUserAction = (user: User): ISetLoggedInUserAction => ({
    type: SET_LOGGED_IN_USER,
    user,
});

export const logoutUser = (): ILogoutUserAction => ({
    type: LOGOUT_USER,
});
